<template>
  <div class="carriers-layout">
    <app-toolbar>
      <template #title></template>
      <template #actions>
        <el-button icon="el-icon-view">
          {{ $t('ACTIONS.VISUALIZE') }}
        </el-button>
        <el-button type="primary"
                   icon="el-icon-edit">
          {{ $t('ACTIONS.EDIT') }}
        </el-button>
      </template>
    </app-toolbar>
    <router-view></router-view>
  </div>
</template>

<script>
import AppToolbar from '@/components/toolbar/Toolbar'

export default {
  name: 'CarriersLayout',
  components: { AppToolbar },
}
</script>
